import { GeometryModel } from "../../shared/utils/cropr";
import gettext from "../../shared/utils/gettext";
import { useMemo } from "react";
import useCroprBackbone from "../../shared/hooks/useCroprBackbone";

export const allCropsId = "0";
export type myCropsItemType = {
  name: string;
  area: number;
  cropfields: { id: number; area: number }[];
};
export const useGroupedCrops = () => {
  const [, cropFieldsCollection] = useCroprBackbone<GeometryModel>("cropfields");
  const myCropFields: [number, number, myCropsItemType][] = useMemo(
    () =>
      cropFieldsCollection
        .filter((cf) => cf.get("crop")) // ignore fields without crop
        .map((c) => [
          c.id,
          c.get("crop"),
          {
            name: c.getRelated("crop", "name"),
            area: c.get("registered_area"),
            cropfields: [{ id: c.id, area: c.get("registered_area") }],
          },
        ]),
    [cropFieldsCollection]
  );

  const myCropsObj = useMemo(() => {
    let accumulator: { [index: number]: myCropsItemType } = {};
    return myCropFields.reduce((acc, [cropfieldId, cropId, cropItem]) => {
      if (!acc[cropId]) acc[cropId] = { name: cropItem.name, area: 0, cropfields: [] };
      if (cropItem.area) acc[cropId].area += cropItem.area;
      acc[cropId].cropfields.push({ id: cropfieldId, area: cropItem.area });
      return acc;
    }, accumulator);
  }, [myCropFields]);

  return useMemo(() => {
    const myCrops = new Map<string, myCropsItemType>(Object.entries(myCropsObj));
    myCrops.set(allCropsId, {
      name: gettext("All crops"),
      area: Array.from(myCrops).reduce((total, [, cropItem]) => total + cropItem.area, 0),
      cropfields: myCropFields.map(([cropfieldId, cropId, cropItem]) => {
        return { id: cropfieldId, area: cropItem.area };
      }),
    });
    return myCrops;
  }, [myCropsObj, myCropFields]);
};
